import { LoadingOutlined } from '@ant-design/icons';
import { Spin, SpinProps } from 'antd';

export const LoadingIndicator = (props: SpinProps) => (
  <div
    role="status"
    aria-live="polite"
    aria-busy="true"
  >
    <Spin
      {...props}
      indicator={<LoadingOutlined spin />}
    />
  </div>
);

